import React, { useEffect } from 'react'
import GuestNavbar from '../../components/navigations/GuestNavbar'
import SupportPage from '../../components/Support/SupportPage'
import Footer from '../../components/landing/Footer'

export default function Support() {
  useEffect(()=>{ window.scrollTo(0,0); },[])
  return (
    <>
      <GuestNavbar />
      <SupportPage />
      <Footer/>
    </>
  )
}


